import axios from 'axios'

export const getProfile = async (data) => {
    try {

        let result = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/profile`,
            data: {
                "line_id": data.line_id
            }
        })

        return result

    } catch (error) {
        return error
    }

}

export const getListMenu = async (data) => {
    try {

        let result = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/menu`,
            data: {
                "line_id": data.line_id,
                "is_rem": data.is_rem,
                "is_pm": data.is_pm,
                "is_rental": data.is_rental,
                "company_id": data.company_id         
            }
        })

        return result

    } catch (error) {
        return error
    }

}
export const middleWareDisclaimer = async (data) => {
    try {

        let result = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/admin/disclaimer/master-disclaimer/url`,
            data: {
                "urlName": data.urlName,
                "currentUrl": data.currentUrl,
                "company_id": data.company_id
            }
        })
        return result

    } catch (error) {
        return error
    }
}

export const getDisclaimerById = async (data) => {
    try {
        let result = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/admin/disclaimer/master-disclaimer/by-id`,
            data: {
                "id": data.id,
                "company_id": data.company_id,
            }
        })
        return result
    } catch (error) {
        return error
    }
}

export const insertDisclaimerLog = async (data) => {
    try {
        let result = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/admin/disclaimer/master-disclaimer/insert-log`,
            data: {
                "master_disclaimer_id": data.master_disclaimer_id,
                "user_id": data.user_id,
                "accept_at": data.accept_at,
                "username": data.username,
                "menu": data.menu,
                "company_id": data.company_id
            }
        })

        return result

    } catch (error) {
        return error
    }
}

export const updateDisclaimer = async (data) => {
    try {
        let result = await axios({
            method: 'put',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/admin/disclaimer/master-disclaimer/update`,
            data: {
                "id": data.id,
                "status": data.status,
                "company_id": data.company_id,
                "is_updated": data.is_updated
            }
        })

        return result

    } catch (error) {
        return error
    }
}

export const getIsAcceptDisclaimer = async (data) => {
    try {
        let result = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/is_accept_disclaimer`,
            data: {
                "line_id": data.line_id,
                "company_id": data.company_id,
                "product_type": data.product_type,
                "master_disclaimer_id": data.master_disclaimer_id
            }
        })
        return result
    }
    catch (error) {
        return error
    }
}